import { Outlet, useOutletContext, useParams } from "react-router-dom";

import { db, firebase } from "astrid-firebase";
import getArtifactsQuery from "astrid-firestore/src/api/artifacts/getArtifactsQuery";
import getDistributionChannelsQuery from "astrid-firestore/src/api/distribution/getDistributionChannelsQuery";
import { useCollectionData, useDocumentData, useLoadingValues } from "astrid-firestore/src/hooks";

import LoadingContext from "../../../ui/components/LoadingContext/LoadingContext";
import useHistory from "../../../ui/hooks/useHistory";

import { useProfile } from "../../../authentication/state/profile";
import { useUser } from "../../../authentication/state/user";

import useProductionArticles from "../../hooks/useProductionArticles";
import ProductionView from "../../views/ProductionView/ProductionView";

export default function Production() {
	const history = useHistory();
	const { modal } = useParams();
	const { production } = useOutletContext();

	const user = useUser();
	const profile = useProfile();

	const [
		[
			producer,
			publisher,
			offers,
			discussionChannels,
			work,
			articles,
			artifacts,
			distributionChannels,
			productionTodos,
		],
		loading,
		error,
	] = useLoadingValues(
		useDocumentData(production && db.collection("organizations").doc(production.producer)),
		useDocumentData(production && db.collection("organizations").doc(production.publisher)),
		useCollectionData(
			production &&
				db.collection("offers").where("deleted", "==", false).where("production.id", "==", production.id),
		),
		useCollectionData(
			production &&
				db
					.collection("discussionChannels")
					.where("deleted", "==", false)
					.where("subject.id", "==", production.id),
		),
		useDocumentData(production.work?.ref),
		useProductionArticles(production),
		useCollectionData(getArtifactsQuery(firebase, { production })),
		useCollectionData(getDistributionChannelsQuery(firebase)),
		useCollectionData(production && production.ref.collection("todos").where("deleted", "==", false)),
	);

	return (
		<LoadingContext data={production} loading={loading} error={error}>
			<ProductionView
				modal={modal}
				offers={offers}
				history={history}
				producer={producer}
				publisher={publisher}
				production={production}
				discussionChannels={discussionChannels}
				productionTodos={productionTodos}
			>
				<Outlet
					context={{
						user,
						profile,
						history,
						production,
						producer,
						publisher,
						offers,
						discussionChannels,
						work,
						articles,
						artifacts,
						distributionChannels,
						productionTodos,
					}}
				/>
			</ProductionView>
		</LoadingContext>
	);
}
